import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ProfileFormNavBtn } from '../ProfileFormNavBtn';
import { useGetCurrentUser } from '../../../../hooks';
import { MyProfileRoutes, SIGN_IN_METHODS_URL } from '../../helper';
import MyProfile from '../../MyProfile';
import { Loader } from '../../../../components';

export const MainForm: React.FC = () => {
	const { data, isLoading } = useGetCurrentUser();

	if (isLoading) {
		return <Loader centerHeight={'100dvh'} />;
	}

	return (
		<MyProfile>
			<Flex flexDirection={'column'} gap={'15px'}>
				<ProfileFormNavBtn
					name={'Name'}
					value={`${data?.firstName} ${data?.lastName}`}
					nextRoute={
						'/' +
						MyProfileRoutes.MY_PROFILE +
						'/' +
						MyProfileRoutes.NAME
					}
				/>
				<ProfileFormNavBtn name={'Email'} value={data?.email} />
				<ProfileFormNavBtn
					name={'Phone'}
					nextRoute={
						'/' +
						MyProfileRoutes.MY_PROFILE +
						'/' +
						MyProfileRoutes.PHONE
					}
					value={`+1 ${data?.phoneNumber || ''}`}
				/>
				<ProfileFormNavBtn
					name={'Sign-in & security'}
					nextRoute={SIGN_IN_METHODS_URL}
					value={'Email link, passkeys, password'}
				/>
			</Flex>
		</MyProfile>
	);
};
